import axiosInstance from '../axiosInterceptor/axiosInstance'

const verifyTransaction = async (data) => {
  const { orgId, vivaPaymentOrderInitialTransactionId } = data
  const url = `v1/orgs/${orgId}/billing/verify-transaction?vivaPaymentOrderInitialTransactionId=${vivaPaymentOrderInitialTransactionId}`
  return axiosInstance.patch(url, null)
}

export default verifyTransaction
